// @ts-nocheck
/* eslint-disable no-loop-func */
import React, { Component } from "react";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Search from "../common/Search";
import { Treebeard } from "./Treebeard";
import customTheme from "./themes/customTheme";
import decorators from "./decorators";
import PubSub from "pubsub-js";
import { eventNames } from "../../constants/eventNames";
import ApiService from "../../services/api.service";
import { apiUrlConfig } from "../../constants/apiUrlConfig";
import * as filters from "../../utils/filter";

class TheHelpTree extends Component {
  constructor(props) {
    super(props);
    this.state = { data: null };
    this.apiService = ApiService.getInstance();
    this.sortedStructure = [
      "Web Test Lab",
      "Kanban Board",
      "Test Case Management",
      "Metrics & Reports",
      "Welcome to ATPT!",
      "Step 1 Registration Process",
      "Step 2 Installation of Agent Exe",
      "Step 3 Overview of Application",
      "Step 4 Creating your first component"
    ];
    this.find = this.find.bind(this);
  }
  componentDidMount() {
    this.getTreeData();
  }
  // Static help tree items for TCM and Metrics modules
  // These use backend file paths in helpDir/ (matching the HTML files we created)
  getStaticHelpItems() {
    return [
      {
        name: "Test Case Management",
        elementType: "directory",
        children: [
          { name: "Dashboard", elementType: "file", path: "helpDir/Test Case Management/1. Dashboard.html" },
          { name: "Test Cases", elementType: "file", path: "helpDir/Test Case Management/2. Test Cases.html" },
          { name: "Defects", elementType: "file", path: "helpDir/Test Case Management/3. Defects.html" },
          { name: "Test Runs", elementType: "file", path: "helpDir/Test Case Management/4. Test Runs.html" },
          { name: "Test Suites", elementType: "file", path: "helpDir/Test Case Management/5. Test Suites.html" },
          { name: "Test Plans", elementType: "file", path: "helpDir/Test Case Management/6. Test Plans.html" },
          { name: "Requirements", elementType: "file", path: "helpDir/Test Case Management/7. Requirements.html" },
          { name: "Automation", elementType: "file", path: "helpDir/Test Case Management/8. Automation.html" },
          { name: "Integrations", elementType: "file", path: "helpDir/Test Case Management/9. Integrations.html" },
          { name: "Reports", elementType: "file", path: "helpDir/Test Case Management/10. Reports.html" },
          { name: "Importing Test Cases", elementType: "file", path: "helpDir/Test Case Management/11. Importing Test Cases.html" },
        ]
      },
      {
        name: "Metrics & Reports",
        elementType: "directory",
        children: [
          { name: "Execution Reports", elementType: "file", path: "helpDir/Metrics & Reports/1. Execution Reports.html" },
          { name: "Automation Metrics", elementType: "file", path: "helpDir/Metrics & Reports/2. Automation Metrics.html" },
          { name: "Test Creation Metrics", elementType: "file", path: "helpDir/Metrics & Reports/3. Test Creation Metrics.html" },
          { name: "Cost Saving Analysis", elementType: "file", path: "helpDir/Metrics & Reports/4. Cost Saving Analysis.html" },
        ]
      }
    ];
  }

  async getTreeData() {
    try {
      const res = await this.apiService.get(apiUrlConfig.help_structure());
      console.log('Help tree data response:', res);

      let payload;
      if (res && res.success && res.payload) {
        payload = res.payload;
      } else {
        // Create a default root if backend has no help data
        payload = { name: "Help", children: [] };
      }

      payload.toggled = true;
      let children = payload.children || [];

      // Merge static help items (TCM, Metrics) with backend items
      const staticItems = this.getStaticHelpItems();
      const existingNames = new Set(children.map(c => c.name));
      for (const item of staticItems) {
        if (!existingNames.has(item.name)) {
          children.push(item);
        }
      }

      payload.children = this.sortChildren(children);
      this.setState({ data: payload });
    } catch (error) {
      console.error('Error fetching help tree data:', error);
      // Even on error, show static help items
      const payload = {
        name: "Help",
        toggled: true,
        children: this.sortChildren(this.getStaticHelpItems())
      };
      this.setState({ data: payload });
    }
  }

  sortChildren = children => {
    let i = 0;
    let sortChildIndex = "";
    while (i < children.length) {
      sortChildIndex = "";
      this.sortedStructure.forEach(item => {
        sortChildIndex = children.findIndex(child => child.name === item);

        if (sortChildIndex !== -1 && i !== sortChildIndex) {
          let tempChild = children[sortChildIndex];
          children[sortChildIndex] = children[i];
          children[i] = tempChild;
        }
      });
      i++;
    }
    children = children.map(item => {
      if (item.children && item.children.length > 0) {
        item.children = this.sortChildren(item.children);
      }
      return item;
    });
    return children;
  };

  find(query) {
    if (!query) {
      return this.getTreeData();
    }
    let filtered = filters.filterTree(this.state.data, query);
    filtered = filters.expandFilteredNodes(filtered, query);
    this.setState({ data: filtered });
  }

  onToggle = (node, toggled) => {
    const { cursor } = this.state;
    if (cursor) {
      cursor.active = false;
    }

    if (node.path) PubSub.publish(eventNames.changeHelpData, { header: node.name || "", path: node.path });

    node.active = true;
    if (node.children && node.children.length) {
      node.toggled = toggled;
    }
    this.setState(() => ({ cursor: node }));
  };

  render() {
    let stateData = this.state && this.state.data;
    const hasData = stateData && stateData.children && Array.isArray(stateData.children) && stateData.children.length > 0;
    
    return (
      <div className="aside-holder">
        <div style={{ display: "flex", marginBottom: "30px" }}>
          <Search width="100%" placeholder="Search the tree..." find={this.find} />
          <IconButton
            aria-label="Expand"
            onClick={() => this.props.togglePanel()}
            className="expand-icon"
            style={{
              background: "#232d3b",
              borderRadius: "0 10px 10px 0",
              paddingLeft: "0",
              color: "rgb(118, 134, 154)"
            }}
          >
            <Icon className="fas fa-angle-double-left" fontSize="medium" />
          </IconButton>
        </div>

        {hasData ? (
          <div className="tree-beard-container-help" onMouseUp={() => {}}>
            <Treebeard
              data={stateData}
              style={customTheme}
              decorators={decorators}
              animations={false}
              onToggle={this.onToggle}
            />
          </div>
        ) : (
          <div style={{ 
            padding: "20px", 
            color: "#a0aec0", 
            textAlign: "center",
            fontSize: "14px"
          }}>
            {!this.state.data ? "Loading help structure..." : "No help content available"}
          </div>
        )}
      </div>
    );
  }
}

export default TheHelpTree;
